<template>
    <component :is="template">
        <v-card elevation="0" tile>
            <v-card-title class="tit tit--lg">
                <span class="pl-4">캐시선물받기</span>
            </v-card-title>
            <v-divider/>
            <v-card-subtitle class="tit tit--xs">
                <div class="pl-4">
                    <v-img src="/images/mypage/present.png" width="128" class="mx-auto my-4" />
                </div>
                <div class="text-center mt-8">
                    <div><b class="black--text">{{ gift?.sender?.name }}</b>님께서</div>
                    <div>보내주신 선물을 받으시겠습니까?</div>
                </div>
            </v-card-subtitle>
            <v-card-text class="tit tit--xs">
                <div class="text-center">선물을 받을경우 <b class="tit tit--xs teal--text">{{ gift.amount.format() }}</b> 캐시가 생성됩니다.</div>
            </v-card-text>
            <v-responsive width="100%" max-width="400" class="mx-auto">
                <v-card-actions class="pb-8">
                    <v-spacer/>
                    <v-btn color="teal" class="white--text" x-large width="100%" max-width="300" @click="take"><v-icon class="mr-2">mdi-gift-outline</v-icon>선물받기</v-btn>
                    <v-spacer/>
                </v-card-actions>
            </v-responsive>
        </v-card>

        <login-dialog ref="loginDialog" />
    </component>
</template>
<script>
import api from "@/api";
import { mdiAccountSearchOutline, mdiGiftOutline } from "@mdi/js";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    components: {
        LoginDialog,
    },
    data(){
        return {
            mdiGiftOutline,
            mdiAccountSearchOutline,

            gift: {
                sender: null,
                receiver: null,
                amount: 0
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { gift } = await api.v1.me.gifts.get({ _id: this.$route.query._gift });
            this.gift = gift;
        },
        login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else {
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("close", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        async take(){
            await this.login();
            await api.v1.me.gifts.take(this.gift);
            alert("선물받기가 완료되었습니다");
        }
    },
    computed: {
        accessToken(){ return this.$store.state.accessToken },
        logoff(){ return !this.accessToken },
        logon(){ return !!this.accessToken },
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); }
    }
}
</script>

<style scoped>
</style>